import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-84bff776")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", { id: "guidelines" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createTextVNode("Safe Zone"),
      /*#__PURE__*/_createElementVNode("span", null, " (dotted line)")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " The safe zone is where all important assets should exist to ensure they do not get cut off during the printing process. This includes images, text and other design elements (that do not bleed). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createTextVNode("Actual Label Size"),
      /*#__PURE__*/_createElementVNode("span", null, " (magenta)")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " This line represents the actual label size and shape. Anything that falls outside of this line will be cut-off. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createTextVNode("Bleed"),
      /*#__PURE__*/_createElementVNode("span", null, " (blue)")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " Make sure your background extends to this line to ensure your design reaches the edge of the label once it's peeled up from the liner. ")
  ])
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", {
            class: "close-svg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'guidelines-modal-close' })
          ])
        ]),
        _hoisted_2
      ], 2)
    ], 2)
  ]))
}